//require('./paypal-donation');

// document.getElementById('newsletter-form').addEventListener('submit', function(e) {
//     e.preventDefault();
//     const email = document.getElementById('email').value;
//     const ccUrl = 'https://visitor.r20.constantcontact.com/manage/optin?v=001GfcdKfB8aovS7pX6kt8E16LAjlliSLT1SmUB8gszDPFx0fgU5hg1r1Glu_yLmA16eXNbsPhzUc6FY5mh6JZOVXfnFJaoxWnw4moGyV5ymOo%3D';
//     // const ccUrl = 'https://goo.gl/NaiEWv';
//     const fullUrl = `${ccUrl}?subscriberProfile.visitorProps[0].value=${encodeURIComponent(email)}`;
//     window.location.href = fullUrl;
// });